






























































































import Vue from 'vue';
import { calender } from 'mostra';
import GModalBase from './GModalBase.vue';

type EntryInfo = {
  entry: any;
  buyer: any;
  buyerCompany: any;
  businessCardImage: string | null;
  icon: string | null;
};

export default Vue.extend({
  name: 'GVisitorCard',
  components: {
    GModalBase,
  },
  props: {
    entry: {
      type: Object as () => EntryInfo,
      required: true,
    },
  },
  data() {
    return {
      showBusinessCardModal: false,
      businessCardImageLoaded: false,
    };
  },
  methods: {
    formatDateTime(dt: any): string {
      return calender.formatDateTime(dt);
    },
    onContact() {
      this.$emit('contact', this.entry);
    },
    onShowBusinessCard() {
      this.businessCardImageLoaded = false;
      this.showBusinessCardModal = true;
    },
  },
});
